/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { V1ReferralProgram } from './V1ReferralProgram'
import {
    V1ReferralProgramFromJSON,
    V1ReferralProgramFromJSONTyped,
    V1ReferralProgramToJSON,
    V1ReferralProgramToJSONTyped
} from './V1ReferralProgram'

/**
 *
 * @export
 * @interface V1ReferralStatus
 */
export interface V1ReferralStatus {
    /**
     *
     */
    programs: Array<V1ReferralProgram>
}

/**
 * Check if a given object implements the V1ReferralStatus interface.
 */
export function instanceOfV1ReferralStatus(
    value: object
): value is V1ReferralStatus {
    if (!('programs' in value) || value['programs'] === undefined) return false
    return true
}

export function V1ReferralStatusFromJSON(json: any): V1ReferralStatus {
    return V1ReferralStatusFromJSONTyped(json, false)
}

export function V1ReferralStatusFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1ReferralStatus {
    if (json == null) {
        return json
    }
    return {
        programs: (json['programs'] as Array<any>).map(
            V1ReferralProgramFromJSON
        )
    }
}

export function V1ReferralStatusToJSON(json: any): V1ReferralStatus {
    return V1ReferralStatusToJSONTyped(json, false)
}

export function V1ReferralStatusToJSONTyped(
    value?: V1ReferralStatus | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        programs: (value['programs'] as Array<any>).map(V1ReferralProgramToJSON)
    }
}
